import ImageWidget from 'nucleus-widgets/lib/Image/ImageWidget';
import { connect } from 'react-redux';

export function mapStateToProps() {
  return {
    enableHyperlink: true
  };
}

export default connect(mapStateToProps)(ImageWidget);



// WEBPACK FOOTER //
// ./src/widgets/ImageWidget.js